import { Link } from 'react-router-dom'

const UploadInfo = ({ currentSurvey }) => {
  if (!currentSurvey) {
    return null
  }
  
  return (
    <div id="upload-info-text">
      <p>
        {currentSurvey.has_data ? (
          <>
            This study currently has{' '}
            <b>{currentSurvey.n} respondents</b> and{' '}
            <b>{currentSurvey.num_variables} variables.</b>
            {' '}To add more data, please use the "Add Data" option from the survey homepage.
          </>
        ) : (
          <>This survey doesn't have any data yet. Upload a data file to get started.</>
        )}
      </p>
    </div>
  )
}

export default UploadInfo